import React, { useEffect, useState } from "react";
import { Segmented } from "antd";
import VitalFormAdd from "./VitalFormAdd";
import "./VitalForm.scss";
import VitalFormHistory from "./VitalFormHistory";
import utils from "utils";
import VitalCharts from "./VitalCharts/VitalCharts";
import VitalChartDrop from "./VitalCharts/VitalChartDrop";
function VitalForm(props) {
  const [selectedTab, setSelectedTab] = useState("addVital");
  const [formActionState, formAction] = useState(false);
  // useEffect(()=>{props?.formAction(formActionState)},[formActionState])
  useEffect(() => {
    if (props?.formAction && typeof props?.formAction == "function") {
      props.formAction(formActionState);
    }
  }, [formActionState]);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const unsavedPopup = (key) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setSelectedTab(key), utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  return (
    <div className="vitalForm">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Segmented
          size="large"
          value={selectedTab}
          onChange={formActionState ? unsavedPopup : handleTabChange}
          options={[
            {
              label: <div>Vitals</div>,
              value: "addVital",
            },
            {
              label: <div>Vitals History</div>,
              value: "vitalHistory",
            },
            {
              label: <div>Vitals Chart</div>,
              value: "vitalChart",
            },
            // {
            //   label: <div>Vital Chart Drop</div>,
            //   value: "vitalChartDrop",
            // },
          ]}
        />
      </div>

      <div style={{ paddingTop: "30px" }} className="vitalFormMainDiv">
        {selectedTab == "addVital" && (
          <VitalFormAdd
            formAction={formAction}
            patientDetails={props?.patientDetails}
          />
        )}
        {selectedTab == "vitalHistory" && (
          <VitalFormHistory patientDetails={props?.patientDetails} />
        )}
        {selectedTab == "vitalChart" && (
          <VitalCharts patientDetails={props?.patientDetails} />
        )}
        {selectedTab == "vitalChartDrop" && (
          <VitalChartDrop patientDetails={props?.patientDetails} />
        )}
      </div>
    </div>
  );
}

export default VitalForm;
